var app = angular.module('leonardo');

var WidgetRecurrenceSchedule = function(ReportService, TemplateService) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    templateUrl: 'views/templates/widget/recurrence-schedule.html',
    priority: 1001,
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@',
      ngRequired: '@',
      name: '@'
    },
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.reportService = ReportService;
      scope.templateService = TemplateService;
      scope.init = false;

      scope.conditions = {};

      scope.dayTypes = [
        {id:'every_x_days', name: 'Every'},
        {id:'every_weekday', name: 'Every weekday at'}
      ];

      scope.monthTypes = [
        {id:0, name: 'Day'},
        {id:1, name: 'The'}
      ];

      scope.yearTypes = [
        {id:0, name: 'On'},
        {id:1, name: 'On the'}
      ];

      scope.weeklyOptions = TemplateService.RECURRENCE_WEEKLY_OPTIONS;

      scope.yearlyOptions = TemplateService.RECURRENCE_YEARLY_OPTIONS.map((op, index) => { return {id: index + 1, name: op} });

      scope.setRecurrence = function(recurrence) {
        scope.conditions = {
          type_recurrence: !isNull(recurrence.type_recurrence) ? recurrence.type_recurrence.toString() : recurrence.type_recurrence,
          sending_time: recurrence.sending_time
        };
        if (!isNull(recurrence.type_recurrence)) {
          switch(recurrence.type_recurrence.toString()) {
            case ReportService.RECURRENCE_SCHEDULE_DAILY:
              scope.conditions.recurrence = recurrence.recurrence;
              if (recurrence.recurrence === 'every_x_days') {
                scope.conditions.every_x_days = recurrence.every_x_days ? parseInt(recurrence.every_x_days) : recurrence.every_x_days;
                if (!scope.init) {
                  scope.conditions.sending_time_all = recurrence.sending_time;
                }
                else {
                  scope.conditions.sending_time_all = recurrence.sending_time_all;
                  scope.conditions.sending_time = recurrence.sending_time_all;
                }
              }
              else {
                if (!scope.init) {
                  scope.conditions.sending_time_day = recurrence.sending_time;
                }
                else {
                  scope.conditions.sending_time_day = recurrence.sending_time_day;
                  scope.conditions.sending_time = recurrence.sending_time_day;
                }
              }
              break;
            case ReportService.RECURRENCE_SCHEDULE_WEEKLY:
              scope.conditions.weekday = recurrence.weekday;
              scope.conditions.every_x_weeks = recurrence.every_x_weeks ? parseInt(recurrence.every_x_weeks) : recurrence.every_x_weeks;
              if (!scope.init) {
                scope.conditions.sending_time_week = recurrence.sending_time;
              }
              else {
                scope.conditions.sending_time_week = recurrence.sending_time_week;
                scope.conditions.sending_time = recurrence.sending_time_week;
              }
              break;
            case ReportService.RECURRENCE_SCHEDULE_MONTHLY:
              scope.conditions.month_type = recurrence.month_type;
              if (recurrence.month_type === 1) {
                scope.conditions.weekday_position_in_month = recurrence.weekday_position_in_month;
                scope.conditions.weekday = recurrence.weekday;
                if (!scope.init) {
                  scope.conditions.sending_time_month_position = recurrence.sending_time;
                }
                else {
                  scope.conditions.sending_time_month_position = recurrence.sending_time_month_position;
                  scope.conditions.sending_time = recurrence.sending_time_month_position;
                }
              }
              else {
                scope.conditions.day_send = recurrence.day_send;
                if (!scope.init) {
                  scope.conditions.sending_time_month = recurrence.sending_time;
                }
                else {
                  scope.conditions.sending_time_month = recurrence.sending_time_month;
                  scope.conditions.sending_time = recurrence.sending_time_month;
                }
              }
              break;
            case ReportService.RECURRENCE_SCHEDULE_YEARLY:
              scope.conditions.year_type = recurrence.year_type;
              if (recurrence.year_type === 1) {
                scope.conditions.weekday_position_in_month = recurrence.weekday_position_in_month;
                scope.conditions.weekday = recurrence.weekday;
                scope.conditions.month_send = recurrence.month_send;
                if (!scope.init) {
                  scope.conditions.sending_time_year_position = recurrence.sending_time;
                }
                else {
                  scope.conditions.sending_time_year_position = recurrence.sending_time_year_position;
                  scope.conditions.sending_time = recurrence.sending_time_year_position;
                }
              }
              else {
                scope.conditions.day_send = recurrence.day_send;
                scope.conditions.month_send = recurrence.month_send;
                if (!scope.init) {
                  scope.conditions.sending_time_year = recurrence.sending_time;
                }
                else {
                  scope.conditions.sending_time_year = recurrence.sending_time_year;
                  scope.conditions.sending_time = recurrence.sending_time_year;
                }
              }
              break;
          }
        }
        scope.ngModelCtrl.$setViewValue(scope.conditions);
        scope.init = true;
      };

      scope.ngModelCtrl.$validators.required = function(modelValue) {
        if (!scope.required) {
          return true;
        }
        if (isNull(scope.conditions.type_recurrence)) {
          return false;
        }
        switch(scope.conditions.type_recurrence.toString()) {
          case ReportService.RECURRENCE_SCHEDULE_DAILY:
            if (isNull(scope.conditions.recurrence)) {
              return false;
            }
            if (scope.conditions.recurrence === 'every_x_days') {
              return !isNull(scope.conditions.every_x_days);
            }
            else {
              return true;
            }
          case ReportService.RECURRENCE_SCHEDULE_WEEKLY:
            return (!isNull(scope.conditions.weekday) && !isNull(scope.conditions.every_x_weeks));
          case ReportService.RECURRENCE_SCHEDULE_MONTHLY:
            if (isNull(scope.conditions.month_type)) {
              return false;
            }
            if (scope.conditions.month_type === 1) {
              return (!isNull(scope.conditions.weekday_position_in_month) && !isNull(scope.conditions.weekday));
            }
            else {
              return !isNull(scope.conditions.day_send);
            }
          case ReportService.RECURRENCE_SCHEDULE_YEARLY:
            if (isNull(scope.conditions.year_type)) {
              return false;
            }
            if (scope.conditions.year_type === 1) {
              return (!isNull(scope.conditions.weekday_position_in_month) &&
                !isNull(scope.conditions.weekday) && !isNull(scope.conditions.month_send));
            }
            else {
              return (!isNull(scope.conditions.month_send) && !isNull(scope.conditions.day_send));
            }
        }
        return false;
      };

      scope.getNum = function(month) {
        switch (month) {
          case '1': return 28;
          case '3':
          case '5':
          case '8':
          case '10':
            return 30;
          default: return 31;
        }
      };

      scope.getArray = function(num) {
        var result = [];
        for (var i = 1; i <= num; i++) {
          result.push(i.toString());
        }
        return result;
      };

      scope.montlyDays = scope.getArray(scope.getNum(scope.conditions.month_send));

      scope.ngModelCtrl.$render = function() {
        var recurrence = scope.ngModelCtrl.$modelValue;
        scope.setRecurrence(recurrence);
      };

      scope.$watch('conditions', function(newValue, oldValue) {
        if (!angular.equals(newValue,oldValue)) {
          scope.setRecurrence(newValue);
        }
      }, true);

      scope.$watch('conditions.month_send', function(newValue){
        scope.montlyDays = scope.getArray(scope.getNum(newValue));
      });

      scope.$watch('conditions.type_recurrence', function(newValue){
        if (newValue == ReportService.RECURRENCE_SCHEDULE_WEEKLY) {
          scope.conditions.every_x_weeks = scope.conditions.every_x_weeks ? parseInt(scope.conditions.every_x_weeks) : 1;
        }
      });

    }
  };
};

app.directive('widgetRecurrenceSchedule', ['ReportService', 'TemplateService', WidgetRecurrenceSchedule]);
